import { FC } from 'react';
import { Controller, useFormContext } from 'react-hook-form';
import { FormInputsProps } from '../types';
import '../index.css';
import { useGetFullInfo } from 'react-easyrocket';
import { CountryCode } from 'libphonenumber-js';
import { InputPhone } from 'src/components/Inputs/InputPhone';
import classNames from 'classnames';
import { getCountryNameByAlpha3Code } from '../utils/getCountryNameByAlpha3Code';
import { validatePhoneNumber } from 'src/utils/validations/validatePhoneNumber';

export const FormPhoneInput: FC<FormInputsProps> = ({ field, defaultValue }) => {
  const { fullInfo, isLoading: isLoadingFullInfo } = useGetFullInfo();
  const { name, title, toShow } = field;
  const { control } = useFormContext();

  const userAlpha2Country = getCountryNameByAlpha3Code(fullInfo?.country);
  const isShowField = toShow && !defaultValue;

  return (
    <Controller
      name={name}
      control={control}
      defaultValue={defaultValue}
      rules={{
        required: { value: toShow, message: 'validation.valueRequired' },
        validate: validatePhoneNumber
      }}
      render={({ field: { onChange, name, value }, fieldState: { error } }) => {
        return (
          <div className={classNames(!isShowField ? 'hidden' : 'w-full')}>
            <p className="font-medium text-map_label mb-2 pl-2.5 self-start">{title}</p>
            <InputPhone
              errorMessage={error?.message as string}
              phone={value}
              onChange={onChange}
              isLoading={isLoadingFullInfo}
              countryCode={userAlpha2Country as CountryCode}
              name={name}
            />
          </div>
        );
      }}
    />
  );
};
